export default __webpack_public_path__ + "static/media/snackHealthgenom.bf1e87ec.svg";